// React Imports
import * as React from 'react';
import {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";

// Mui Imports
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import {
    Select
} from "@mui/material";

// App Imports

import CdpvMegaPivot from "./CdpvMegaPivot";
import {changeWorkQueue} from "../workQueueSlice";


// Main Function
export default function CdpvMegaPivotDrawer() {


    // ****************** BEGIN STATES ****************************

    const [showContractDataPointValueDrawer, setShowContractDataPointValueDrawer] = React.useState(false);
    const [submitting, setSubmitting] = useState(true);
    const [cdpvFormState, setCdpvFormState] = useState(false);
    const [cdpvExpression, setCdpvExpression] = useState([useSelector((state) => state.contractDataPointValueSlc.value.expression)]);

    // ****************** END STATES ****************************


    // ****************** BEGIN STORE ****************************

    const dispatchData = useDispatch() ;
    const selectorContractDataPointValueId = useSelector((state) => state.contractDataPointValueSlc.value.id);
    const selectorContractDataPointId = useSelector((state) => state.contractDataPointSlc.value.id);
    const selectorCdpvDrawerState = useSelector((state) => state.contractDataPointValueSlc.value.cdpvDrawerState);
    const selectorCdpvFormState = useSelector((state) => state.contractDataPointValueSlc.value.cdpvFormState);
    const selectorCdpvDrawerMode = useSelector((state) => state.contractDataPointValueSlc.value.cdpvDrawerMode);

    const selectorCdpvMegaPivotState = useSelector((state) => state.workQueueSlc.value.cdpvMegaPivotState);

    // ****************** END STORE ****************************


    // ****************** BEGIN REGISTER ****************************


    // ****************** END REGISTER ****************************


    // *********************** BEGIN DROPDOWNS **************************

    //
    // const [cdpvDropdown, setCdpvDropdown] = useState([]);
    // const [selectedCDPV, setSelectedCDPV] = useState(null);
    // // const [selectedCDPVRow, setSelectedCDPVRow] = useState(null);
    // const selectedCDPVRow = null;
    //
    // function fetchCDPVbyID(cdpvId) {
    //     getCDPVbyId(cdpvId)
    //         // .then(function(res){

    //         .then(data => {
    //             console.log("that was the cdpv single data");
    //             console.log(data);
    //             setCdpvExpression(data.expression);
    //             dispatchData(changeContractDataPointValue(
    //                     {id: data[0].id
    //                         ,
    //                         contractDataPointId: data[0].contractDataPointId,
    //                         contractDataPointValueFilterId: data[0].contractDataPointValueFilterId,
    //                         ordinalNumber: data[0].ordinalNumber, iterationNumber: data[0].iterationNumber,
    //                         extendInd: data[0].extendInd, value: data[0].value,
    //                         expression: data[0].expression, expressionDescription: data[0].expressionDescription,
    //                         expressionTranslation: data[0].expressionTranslation,
    //                         sourceContractDataPointValueId: data[0].sourceContractDataPointValueId,
    //                         origin: data[0].origin, status: data[0].status,
    //                         mockValue: data[0].mockValue,
    //                         createdOn: data[0].createdOn,createdBy: data[0].createdBy,
    //                         lastModifiedOn: data[0].lastModifiedOn,lastModifiedBy: data[0].lastModifiedBy
    //                     }
    //                 )
    //             )
    //         })};
    //

    //
    // const fetchCdpvForDropdowns = () =>
    //     getCDPVbyCDPid(selectorContractDataPointId)

    //         .then(data => {
    //             console.log(data);
    //             // setItems(data.sort((a, b) => a.name > b.name ? 1 : -1) );
    //             setCdpvDropdown(data);
    //         })
    // useEffect(() => {
    //     console.log("This is for the cdpv dropdown...");
    //     fetchCdpvForDropdowns();
    // }, []);
    //
    //
    // const handleCDPVChange = (idEvent) => {
    //     fetchCDPVbyID(idEvent.target.value)
    //     setCdpvFormState(true);
    //     console.log("The CDPV Form State");
    //     console.log(selectorCdpvFormState);
    //
    // };

// *********************** END DROPDOWNS **************************


    // ****************** BEGIN MISC ****************************
    //
    // const onFinishFailed = errorInfo => {
    //     alert(JSON.stringify(errorInfo, null, 2));
    // };


    const closeCdpvMegaPivotDrawer = () => {
        dispatchData(changeWorkQueue({cdpvMegaPivotState: false, selectedAttributeId: null}));
    };

    // ****************** END MISC ****************************
    //
    // function cdpvMegaPivotSelect(){
    //     return(
    //         <Box>
    //             <p>Select the value record to edit.</p>
    //             <Select
    //                 onChange={handleCDPVChange}
    //             >
    //                 {cdpvDropdown.map((cdpvItem) =>
    //                     // <Tooltip  enterDelay={1000}  title={"Expression: " + cdpvItem.expression}>
    //                     <MenuItem sx={{ width: 700 }} value={cdpvItem.id}>{cdpvItem.dataPointName} {cdpvItem.mockValue} {cdpvItem.expression}
    //                     </MenuItem>
    //                 )}
    //             </Select>
    //         </Box>)}



    // ****************** BEGIN RETURN ****************************

    return (
        <div>

            <Drawer
                sx={{ width: '1700px' }}
                anchor='right'
                // open={true}
                // initialState={{open: true}}
                open={selectorCdpvMegaPivotState}
                initialState={{open: false}}
                onClose={closeCdpvMegaPivotDrawer}
            >
                <CdpvMegaPivot
                    closeCdpvMegaPivotDrawer
                />

            </Drawer>
        </div>
    );

    // ****************** END RETURN ****************************

}
